export default "__VITE_ASSET__lP$1g2Wp__"